module.exports = __webpack_public_path__ + "media/assets/images/banner-information-99792a773aa2bb1e39079f1b2df6024a.jpg";